import { render, staticRenderFns } from "./SfRating.vue?vue&type=template&id=643eca84&functional=true&"
import script from "./SfRating.vue?vue&type=script&lang=js&"
export * from "./SfRating.vue?vue&type=script&lang=js&"
import style0 from "./SfRating.vue?vue&type=style&index=0&id=643eca84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports